import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function DateFormatConfirmation(props) {

  let dateFormatOptions = [{
    value: 'MM/dd/YYYY',
    name: 'MM/dd/YYYY'
  }, {
    value: 'dd/MM/YYYY',
    name: 'dd/MM/YYYY'
  }, {
    value: 'dd-MMM-YYYY',
    name: 'dd-MMM-YYYY'
  }, {
    value: 'dd MMMM YYYY',
    name: 'dd MMMM YYYY'
  }, {
    value: 'MMMM dd YYYY',
    name: 'MMMM dd YYYY'
  }, {
    value: 'YYYY/MM/dd HH:mm:ss',
    name: 'YYYY/MM/dd HH:mm:ss'
  }, {
    value: 'MM/dd/YYYY HH:mm:ss',
    name: 'MM/dd/YYYY HH:mm:ss'
  }, {
    value: 'dd/MM/YYYY HH:mm:ss',
    name: 'dd/MM/YYYY HH:mm:ss'
  }, {
    value: 'dd-MMM-YYYY HH:mm:ss',
    name: 'dd-MMM-YYYY HH:mm:ss'
  }, {
    value: 'dd MMMM YYYY HH:mm:ss',
    name: 'dd MMMM YYYY HH:mm:ss'
  }, {
    value: 'MMMM dd YYYY HH:mm:ss',
    name: 'MMMM dd YYYY HH:mm:ss'
  }, {
    value: 'YYYY-MM-dd HH:mm:ss',
    name: 'YYYY-MM-dd HH:mm:ss'
  }
  ]


  const handleChange = (event) => {
    props.setSelectedFormat(event.target.value);
  }
  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          {'Please select date format for the report.'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className='alert-description'>
            <FormControl sx={{ m: 0, width: 'auto', minWidth: 200 }}>
              <Select
                value={props.selectedFormat}
                onChange={handleChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem disabled value="">
                  <em>Select Format</em>
                </MenuItem>
                {dateFormatOptions.map((option) => (
                  <MenuItem value={option.value}>{option.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" autoFocus
            onClick={props.confirmDateFormat}
            disabled={props.selectedFormat === ''}>
            OK
          </Button>
          <Button variant="outlined" color="primary" onClick={props.close} >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}